import { Icon } from '@iconify/react'
import { PATH } from './router_path'

const ICON_STYLE_CONFIG = {
  base: 'text-2xl text-gray-accent',
}

const Icons = {
  book: {
    light: 'ph:book-bold',
    dark: 'ph:book-fill',
  },
  account: {
    light: 'ph:users-bold',
    dark: 'ph:users-fill',
  },
  system: {
    light: 'ph:hard-drives-bold',
    dark: 'ph:hard-drives-fill',
  },
}

export const Tabs = {
  books: [
    { path: PATH.BOOK.LIST, name: 'Thông tin sách' },
    { path: PATH.BOOK.PACKAGE, name: 'Quản lý gói sách' },
    { path: PATH.BOOK.BORROW, name: 'Quản lý mượn trả' },
  ],
  account: [
    { path: PATH.ACCOUNT.LIST, name: 'Thông tin tài khoản' },
    { path: PATH.ACCOUNT.GUEST.LIST, name: 'Tài khoản khách' },
  ],
  system: [
    {
      path: PATH.SYSTEM.DECENTRALIZE_ADMINISTRATION.LIST,
      name: 'Phân quyền quản trị',
    },
    { path: PATH.SYSTEM.STATISTICAL_REPORT.LIST, name: 'Báo cáo thống kê' },
  ],
}

const SidebarItem = ({ title, lightIcon, darkIcon, dropChildren }) => ({
  title,
  lightIcon: <Icon icon={lightIcon} className={ICON_STYLE_CONFIG.base} />,
  darkIcon: <Icon icon={darkIcon} className={ICON_STYLE_CONFIG.base} />,
  dropChildren,
})

export const Data_sidebar = [
  SidebarItem({
    title: 'Quản lý sách',
    lightIcon: Icons.book.light,
    darkIcon: Icons.book.dark,
    dropChildren: Tabs.books,
  }),
  SidebarItem({
    title: 'Quản lý tài khoản',
    lightIcon: Icons.account.light,
    darkIcon: Icons.account.dark,
    dropChildren: Tabs.account,
  }),
  SidebarItem({
    title: 'Quản lý hệ thống',
    lightIcon: Icons.system.light,
    darkIcon: Icons.system.dark,
    dropChildren: Tabs.system,
  }),
]
